import { render, staticRenderFns } from "./ModalPopup.vue?vue&type=template&id=a5636bec&scoped=true"
import script from "./ModalPopup.vue?vue&type=script&lang=js"
export * from "./ModalPopup.vue?vue&type=script&lang=js"
import style0 from "./ModalPopup.vue?vue&type=style&index=0&id=a5636bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5636bec",
  null
  
)

export default component.exports